import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';

var _class, _descriptor;

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      service — incoming-call ringtone via Web Audio API
 *   extends:   Service (ember, base class)
 *   template:  none
 *   key:       start (gated on session.option_field.income_calls.ringtone),
 *              stop (clears timers, closes the AudioContext)
 *   uses:      session (option_field), global window.AudioContext
 *   siblings:  controllers/application.js (calls ringtone.start()/stop())
 *   tests:     ringtone-test.js
 *   gotchas:   start() self-stops after 5s (_ringtoneAutoStop) and reschedules
 *              chimes every 2200ms while active; stop() must be called on
 *              teardown or a stray AudioContext/timer can outlive the caller
 *
 * Servizio Ringtone
 * Gestisce la suoneria delle chiamate in ingresso tramite Web Audio API.
 * Estratto dal god-controller application (maintainability 4.2), comportamento invariato.
 */
let RingtoneService = (_class = class RingtoneService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  /**
   * Avvia la suoneria tramite Web Audio API con tono moderno (tre note ascendenti).
   * Si ferma automaticamente dopo 5 secondi.
   */
  start() {
    if (this.session.option_field?.income_calls?.ringtone !== true) return;
    this.stop();

    /* istanbul ignore next -- Web Audio API device glue (AudioContext oscillator scheduling) (§11.4) */
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      const ctx = new AudioContext();
      this._ringtoneCtx = ctx;

      // Tre note veloci ascendenti: Mi5 → Sol#5 → Si5 (accordo moderno)
      const notes = [659, 831, 988];
      const playChime = startTime => {
        notes.forEach((freq, i) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.type = 'sine';
          osc.frequency.value = freq;
          const t = startTime + i * 0.1;
          gain.gain.setValueAtTime(0, t);
          gain.gain.linearRampToValueAtTime(0.18, t + 0.02);
          gain.gain.exponentialRampToValueAtTime(0.001, t + 0.45);
          osc.start(t);
          osc.stop(t + 0.5);
        });
      };
      const scheduleChimes = () => {
        if (!this._ringtoneCtx) return;
        const t = ctx.currentTime;
        playChime(t);
        playChime(t + 0.7);
        this._ringtoneTimeout = setTimeout(scheduleChimes, 2200);
      };
      scheduleChimes();

      // Auto-stop dopo 5 secondi
      this._ringtoneAutoStop = setTimeout(() => this.stop(), 5000);
    } catch (e) {
      // Web Audio API non disponibile, silenzio
    }
  }

  /**
   * Ferma la suoneria e libera le risorse audio.
   */
  stop() {
    if (this._ringtoneAutoStop) {
      clearTimeout(this._ringtoneAutoStop);
      this._ringtoneAutoStop = null;
    }
    if (this._ringtoneTimeout) {
      clearTimeout(this._ringtoneTimeout);
      this._ringtoneTimeout = null;
    }
    if (this._ringtoneCtx) {
      try {
        this._ringtoneCtx.close();
      } catch (e) {
        // già chiuso
      }
      this._ringtoneCtx = null;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { RingtoneService as default };
//# sourceMappingURL=ringtone.js.map
